"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePhoneNumberInputStyles = void 0;
var core_1 = require("@material-ui/core");
var _colors_1 = require("../../../style/commons/_colors");
exports.usePhoneNumberInputStyles = (0, core_1.makeStyles)(function () { return ({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    errorRoot: {
        paddingBottom: 16,
    },
    container: {
        '& .invalid-number-message': {
            left: 0,
            top: '42px',
            background: 'transparent',
            padding: 0,
            color: _colors_1.mediumRed,
            fontSize: '12px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: 'normal',
            zIndex: 'auto',
        },
        '& > .invalid-number': {
            backgroundColor: "white !important",
            borderColor: "".concat(_colors_1.mediumRed, " !important"),
        },
    },
    input: {
        width: '100% !important',
        borderRadius: '4px !important',
        border: "solid 1px ".concat(_colors_1.brandPrimaryLight, " !important"),
        backgroundColor: "".concat(_colors_1.secondaryHover, " !important"),
        fontSize: '16px !important',
        height: '40px !important',
        letterSpacing: 'normal !important',
        color: "".concat(_colors_1.darkSecondary, " !important"),
        '&::placeholder': {
            color: "".concat(_colors_1.textInputColor, " !important"),
        },
        '&:focus': {
            borderColor: "".concat(_colors_1.brandPrimaryExtraDark, " !important"),
            border: '2px solid !important',
            backgroundColor: "".concat(_colors_1.lightSecondary, " !important"),
        },
        '&$inputDisabled': {
            opacity: 0.4,
        },
        '&$inputDisabled:hover': {
            borderColor: "".concat(_colors_1.brandPrimaryDark, " !important"),
        },
        '&:hover': {
            borderColor: "".concat(_colors_1.primaryColor, " !important"),
        },
    },
    flagButton: {
        background: "".concat(_colors_1.secondaryHover, " !important"),
        height: '40px',
        border: "solid 1px ".concat(_colors_1.brandPrimaryLight, " !important"),
    },
    dropdown: {
        borderRadius: '4px !important',
        margin: '2px 0 10px -1px !important',
        boxShadow: '1px 4px 10px rgba(0,0,0,0.2) !important',
        color: "".concat(_colors_1.textInputColor, " !important"),
        '& li': {
            '& .dial-code': {
                color: "".concat(_colors_1.mediumLightBlue, " !important"),
            },
            '&.highlight': {
                backgroundColor: "".concat(_colors_1.lightBlue, " !important"),
            },
        },
        '& li:hover': {
            backgroundColor: "".concat(_colors_1.lightLightBlue, " !important"),
        },
    },
    label: {
        fontFamily: 'Roboto',
        fontSize: '14px',
        lineHeight: '17px',
        fontWeight: 'normal',
        color: _colors_1.textInputColor,
        marginBottom: 4,
    },
}); });
